// @flow
import axios from 'axios'
import { reset } from 'redux-form'
import { push } from 'react-router-redux'
import get from 'lodash/get'
import { resetAuthHeader } from '../axios'
import {
  ALERT,
  AUTHENTICATION_FAILURE,
  AUTHENTICATION_SUCCESS,
  AUTHENTICATION_REQUEST,
  FETCH_FAVORITES_SUCCESS,
  LOGOUT,
  SIGNUP_ERROR
} from '../constants'
import { User } from '../types'

function fetchFavorites(dispatch, userId: number) {
  return axios.get(`/users/${userId}/favorites`).then((response) => {
    dispatch({ type: FETCH_FAVORITES_SUCCESS, favorites: response.data })
  })
}

export function setCurrentUser(
  dispatch: Function,
  response: { meta: { token: string }, data: User }
) {
  return new Promise((resolve) => {
    localStorage.setItem('token', JSON.stringify(response.meta.token))
    resetAuthHeader()
    fetchFavorites(dispatch, response.data.id)
    dispatch({ type: AUTHENTICATION_SUCCESS, user: response.data })
    resolve(response.data)
  })
}

export function login(data: { email: string, password: string }) {
  return (dispatch: Function) =>
    axios
      .post('/sessions', data)
      .then((response) => {
        dispatch(reset('login'))
        setCurrentUser(dispatch, response)
        dispatch(push('/properties'))
      })
      .catch(({ message }) => {
        dispatch({ type: ALERT, message })
      })
}

export function signup(data: {
  user: { name: string, email: string, password: string }
}) {
  return (dispatch: Function) =>
    axios
      .post('/registrations', data)
      .then((response) => {
        setCurrentUser(dispatch, response)
        dispatch(push('/properties'))
      })
      .catch(({ errors }) => {
        dispatch({ type: ALERT, message: 'Error signing up', timeout: 3000 })
        dispatch({ type: SIGNUP_ERROR, errors })
      })
}

export function logout() {
  return (dispatch: Function) =>
    axios
      .delete('/sessions')
      .then(() => {
        localStorage.removeItem('token')
        dispatch({ type: LOGOUT })
        dispatch(push('/'))
      })
      .catch(() => {
        localStorage.removeItem('token')
        window.location = '/'
      })
}

export function authenticate() {
  return (dispatch: Function) => {
    dispatch({ type: AUTHENTICATION_REQUEST })
    return axios
      .post('/sessions/refresh')
      .then((response) => {
        setCurrentUser(dispatch, response)
      })
      .catch(() => {
        localStorage.removeItem('token')
        window.location = '/'
      })
  }
}

export const unauthenticate = () => ({ type: AUTHENTICATION_FAILURE })

export function forgotPassword(data: { email: string }) {
  return (dispatch: Function) =>
    axios
      .post('/passwords/forgot', data)
      .then(() => {
        dispatch(reset('forgotPassword'))
        dispatch(push('/login'))
        dispatch({
          type: ALERT,
          klass: 'primary',
          timeout: 4000,
          message: 'Please check your email for a password reset link'
        })
      })
      .catch(({ message }) => {
        dispatch({ type: ALERT, message })
      })
}

export function resetPassword(data: { token: string, password: string }) {
  return (dispatch: Function) =>
    axios
      .post('/passwords/reset', data)
      .then((response) => {
        dispatch(reset('resetPassword'))
        setCurrentUser(dispatch, response)
        dispatch(push('/'))
      })
      .catch(({ message }) => {
        dispatch({ type: ALERT, message })
      })
}

function facebookLoginOrSignup(dispatch: Function, user: Object) {
  axios
    .post('/registrations/facebook', { user })
    .then((response) => {
      setCurrentUser(dispatch, response)
      dispatch(push('/properties'))
    })
    .catch(() => {
      dispatch(push('/login'))
      dispatch({ type: ALERT, message: 'Error logging in', timeout: 4000 })
    })
}

const fbGraph = axios.create({ baseURL: 'https://graph.facebook.com' })

export function fetchFbProfile(accessToken: string) {
  return (dispatch: Function) =>
    fbGraph
      .get(`/me?fields=name,email&access_token=${accessToken}`)
      .then((response) => {
        const user = {
          name: response.data.name,
          email: response.data.email,
          facebook_id: response.data.id
        }
        facebookLoginOrSignup(dispatch, user)
      })
      .catch((error) => {
        const message = get(error, 'response.data.error.message', 'Login error')
        dispatch(push('/login'))
        dispatch({ type: ALERT, message })
      })
}



// WEBPACK FOOTER //
// ./src/actions/session.js